// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"d0ef6515ee02dfa9cd1c","563":"b019f312cd1e962a768a","812":"e051862e0510a1553380","919":"6c385bb18178aff645f5"}[chunkId] + ".chunk.js";
};